import { RouterModule, Routes } from '@angular/router';

import { MenuComponent } from '@app/modules/menu/menu.component';
import { NgModule } from '@angular/core';
import { SiteResolver } from '@app/core/site.service.resolver';
import { ProductsDialogEntryComponent } from '@app/modules/menu/components/products-dialog-entry/products-dialog-entry.component';
import { DealsDialogEntryComponent } from '@app/modules/menu/components/deals-dialog-entry/deals-dialog-entry.component';

const routes: Routes = [
  {
    children: [
      {
        component: ProductsDialogEntryComponent,
        path: ':productName/:productId'
      },
      {
        component: DealsDialogEntryComponent,
        path: 'offers/:productName/:dealId'
      }
    ],
    component: MenuComponent,
    path: ':displayGroup',
    resolve: {
      siteResolver: SiteResolver
    }
  },
  {
    component: MenuComponent,
    path: '',
    resolve: {
      siteResolver: SiteResolver
    }
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class MenuRoutingModule { }
